import React, { useState, memo } from 'react'
import { styled } from '@mui/material/styles'
import Accordion from '@mui/material/Accordion'
import MuiAccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import { faChevronRight } from '@fortawesome/pro-light-svg-icons'

import FaIcon from '../faIcon/FaIcon'
import Text from '../text/Text'

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<FaIcon icon={faChevronRight} />}
    {...props}
  />
))(() => ({
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)'
  }
}))

const CustomAccordions = ({ data }) => {
  const [expanded, setExpanded] = useState('')
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false)
  }
  return data.map(({ title, description, customDesc }, index) => {
    const id = index + 1
    return (
      <Accordion
        expanded={expanded === `panel${id}`}
        onChange={handleChange(`panel${id}`)}
        key={index}
      >
        <AccordionSummary
          aria-controls={`panel${id}-content`}
          id={`panel${id}-header`}
        >
          <Text label={`${id}. ${title}`} fontWeight={700} />
        </AccordionSummary>
        <AccordionDetails sx={{ pb: 0, pt: 0 }}>
          <Text
            component='div'
            label={customDesc || description}
            sx={{
              ml: 2,
              a: {
                color: 'inherit'
              },
              '& > p, & > ol': {
                mt: 0
              }
            }}
          />
        </AccordionDetails>
      </Accordion>
    )
  })
}

export default memo(CustomAccordions)
